import React, { useCallback, useState, useEffect } from "react";
import AssetHeader from "./AssetHeader";
import AssetList from "./AssetList";
import AssetListHeader from "./AssetListHeader";
import AssetMobData from "./AssetMobData";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faMagnifyingGlass, faSearch } from "@fortawesome/free-solid-svg-icons";
import "./assets.css";
import SortButton from "../pools/SortButton";
import SwapHeaderMenu from "../swap/SwapHeaderMenu";
import AssetSortbtn from "./AssetSortbtn";
import MyAssets from "./MyAssets";
import { useToken } from "../../hooks/useToken";
import { useRecoilValue } from "recoil";
import { configState } from "../../context/configState";
import ToggleSwitch from "../common/input/ToggleSwitch";

type SortOrder = "ascn" | "desc";

const AssetListContainer = () => {
  const [text, setText] = useState("");
  const [activeMenu1, setActiveMenu1] = useState("All");

  const [sortKey, setSortKey] = useState("asset_name");
  const [sortOrder, setSortOrder] = useState<SortOrder>("desc");

  // function changeFunc() {
  //   var selectBox = (document.getElementById("selectBox") as HTMLSelectElement);
  //   var selectedValue = selectBox.options[selectBox.selectedIndex].value;
  //   if(selectedValue==="1"){
  //     setSortOption("Balance");
  //   }else{
  //     setSortOption("Network")
  //   }
  //  }

  const { getBalance } = useToken();
  const { assetsMap } = useRecoilValue(configState);

  let balanceMap: Record<string, number> = {};
  const [balMp, setBalMp] = useState(balanceMap);
  const fetchBalance = async (asset: any) => {
    if(asset === "sSCRT"){
      const balance = await getBalance(assetsMap[asset].display_denom, true);
      balanceMap[asset] =
      balance !== null ? (Number(balance) ? Number(balance) : 0) : -1;
      setBalMp(balanceMap);
    }
    else{
      const balance = await getBalance(assetsMap[asset].display_denom);
      balanceMap[asset] =
        balance !== null ? (Number(balance) ? Number(balance) : 0) : -1;
    }
  };
  let assets = Object.keys(assetsMap);
  useEffect(() => {
    assets.map(async (asset) => {
      await fetchBalance(asset);
    });
    setBalMp(balanceMap);
  }, [sortKey, sortOrder]);

  const handlesort = (sortorder: any) => {
    setSortOrder(sortorder === "desc" ? "ascn" : "desc");
  };

  const orderby = (val: any) => {
    setSortKey(val);
  };

  const handleClick = () =>{
    activeMenu1 ==="All" ? 
    setActiveMenu1("MyFav") : 
    setActiveMenu1("All");
  }

  const handleRefetch = () =>{
    fetchBalance("sSCRT");
  }


  return (
    <div className="asset-list-container">
      <MyAssets />
      <AssetHeader />

      <div className="pool-subhead">
        <div className="swap-header-menu-component">
          {/* <SwapHeaderMenu
            activeMenu={activeMenu1}
            onClick={() => setActiveMenu1("All")}
            name={"All"}
          />
          <SwapHeaderMenu
            activeMenu={activeMenu1}
            onClick={() => setActiveMenu1("MyFav")}
            name={"MyFav"}
          /> */}
          <ToggleSwitch label="Show Favourites" handleClick={handleClick}/>
        </div>
        <div className="poolfilter">
          <div className="poolSearch">
            <div>
              <FontAwesomeIcon icon={faSearch} />
            </div>
            <input
              type="text"
              placeholder="Search Pools"
              value={text}
              onChange={(e) => setText(e.target.value)}
            />
          </div>

          <div>
            <AssetSortbtn handlesort={handlesort} orderby={orderby} />
          </div>
        </div>
      </div>

      <table className="asset-list-table all-pool-table-head">
        <AssetListHeader
          sortOrder={sortOrder}
          handlesort={handlesort}
          sortKey={sortKey}
          orderby={orderby}
        />
        <AssetList
          searchtext={text}
          mode={activeMenu1}
          sortoption={sortKey}
          sortOrder={sortOrder}
          balanceMap={balMp}
          handleRefetch={handleRefetch}
        />
      </table>
      {/* <div className="asset-list-mob-data">
        <AssetMobData />
      </div> */}
    </div>
  );
};

export default AssetListContainer;
